export function toggleElementClassConditionally(nodes, predicate, className) {
  nodes.forEach((node) => {
    toggleElementClass(node, predicate(node), className);
  });
}

export function toggleElementClass(node, activate, className) {
  if (activate) {
    node.classList.add(className);
  } else {
    node.classList.remove(className);
  }
}
